import { api } from '../../api';

const ObterDadoCadastral = async (representedCpfCnpj) => {
  const response = await api.get('/DadoCadastral/ObterDadoCadastral', {
    params: { representedCpfCnpj: representedCpfCnpj || '' }
  });

  if (response.sucesso) {
    return response.data;
  } else {
    return null;
  }
};

const ObterPessoaFisica = async (representedCpfCnpj) => {
  const response = await api.get('/DadoCadastral/ObterPessoaFisica', {
    params: { representedCpfCnpj: representedCpfCnpj || '' }
  });

  if (response.sucesso) {
    return response.data;
  } else {
    return null;
  }
};

const ObterPessoaJuridica = async (Cnpj) => {
  const response = await api.get('/DadoCadastral/ObterPessoaJuridica', {
    params: { representedCpfCnpj: Cnpj || '' }
  });

  if (response.sucesso) {
    return response.data;
  } else {
    return null;
  }
};


const NecessarioAtualizarDadoCadastral = async (representedCpfCnpj) => {
  const response = await api.get(
    '/DadoCadastral/NecessarioAtualizarDadoCadastral', {
    params: { representedCpfCnpj: representedCpfCnpj || '' }
  }
  );

  if (response.sucesso) {
    return response.data;
  } else {
    return null;
  }
};

export { ObterDadoCadastral, NecessarioAtualizarDadoCadastral, ObterPessoaFisica, ObterPessoaJuridica };
